import React from 'react';
import {
    AutocompleteInput,
    BooleanField,
    Datagrid,
    Filter,
    List,
    ReferenceField,
    ReferenceInput,
    TextField,
    TextInput
} from 'react-admin';

const AccessDeviceFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
        <ReferenceInput label="Tenant" source="tenantId" reference="tenants" alwaysOn allowEmpty
                        {...props}
                        sort={{field: 'name', order: 'ASC'}}
                        perPage={999}
        >
            <AutocompleteInput optionText="name"/>
        </ReferenceInput>
    </Filter>
);

export const AccessTerminalList = props => (
    <List filters={<AccessDeviceFilter/>} {...props} exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="deviceNo"/>
            <BooleanField source="sendNotification"/>
            <BooleanField source="enabled"/>
            <ReferenceField source="tenantId" reference="tenants" allowEmpty>
                <TextField source="name"/>
            </ReferenceField>
        </Datagrid>
    </List>
);

export default AccessTerminalList
